<!-- section is the parent container that holds the environment info -->
<section *ngIf="showInfoBox">
  <div class="infoBox" [style.background-color]="environmentBannerColor">
    <div class="infoText" (click)="expandedInfoBox = !expandedInfoBox">{{ expandedInfoBox ? 'hide' : 'show' }}</div>
    <div class="envMessage" *ngIf="expandedInfoBox">
      <strong class="whiteT"
        ><p>{{ environmentBannerMessage }}</p></strong
      >
    </div>
  </div>
</section>
<div class="whiteBG">
  <div class="bodyShell">
    <router-outlet></router-outlet>
  </div>
</div>
